import type { SimilarGoodsItem } from 'shared/src/api/goodsService/getSimilarGoods/types';
import type { GoodsFirstPageRenderingModel } from 'shared/src/api/types';
import { isNotNil } from 'shared/src/utils';

export const buildFirstPageRendering = (
  item: SimilarGoodsItem,
): GoodsFirstPageRenderingModel => {
  if (isNotNil(item.first_page_rendering)) {
    return item.first_page_rendering;
  }

  return {
    goods_name: item.name,
    market_name: item.market.name,
    discount_rate: item.discount_rate,
    original_price: item.linked_option.original_price,
    price: item.price,
  };
};
